import { atom } from 'jotai';

export const magicEditPromptAtom = atom('');
